export default "__VITE_ASSET__BHQsBgAV__"